export enum PoStatusCode {
  NewUnposted = '1000.00',
  // PostedNotSubmitted = '1500.00',
  OpenIncomplete = '2000.00',
  Complete = '3000.00',
}
